import clsx from "clsx";
import type { ComponentProps } from "react";

import { LineMap } from "@features/how-to-get-section/ui/line-map";

import type { HowToGetSectionBase } from "@shared/content-types/schemas/sections.schema";
import { ButtonWithIcon } from "@shared/ui/button-with-icon";
import { Container } from "@shared/ui/container";
import { Image } from "@shared/ui/image";
import { InfoList } from "@shared/ui/info-list";
import { InfoListItem } from "@shared/ui/info-list-item";
import { Body } from "@shared/ui/typography";

import s from "./how-to-get-section.module.scss";

export type HowToGetSectionProps = ComponentProps<"div"> &
  HowToGetSectionBase & {
    className?: string;
  };

export const HowToGetSection = (props: HowToGetSectionProps) => {
  const { className, subtitle, title, items, button, cities } = props;

  return (
    <section className={clsx(s.root, className)}>
      <Image
        src="/images/htg.webp"
        height="100%"
        width="100%"
        alt="background image"
        className={s.bg}
      />
      <Container className={s.content}>
        <div className={s.left}>
          <div className={s.header}>
            {subtitle != null && subtitle !== "" && (
              <Body
                weight="semiBold"
                size="uppercase-small"
                className={s.subtitle}
              >
                {subtitle}
              </Body>
            )}
            {title != null && title !== "" && (
              <p className={s.title}>{title}</p>
            )}
          </div>
          <div className={s.bottom}>
            <InfoList>
              {items?.map((item, index) =>
                item ? (
                  <InfoListItem
                    key={(item as { id?: number }).id ?? `item-${index}`}
                    title={item?.title ?? ""}
                    value={item?.value ?? ""}
                    icon={
                      item.icon?.name
                        ? {
                            name: item.icon.name,
                            color: item.iconColor ?? "violet",
                          }
                        : undefined
                    }
                  />
                ) : null,
              )}
            </InfoList>
            {button?.link && button?.text && (
              <ButtonWithIcon
                href={button.link || "/"}
                iconName={button.pageIcon?.icon?.name || "plus"}
                iconFillColor={button.pageIcon?.fillColor || "azure"}
                iconStrokeColor={button.pageIcon?.strokeColor || "white"}
                iconSvgCode={button.pageIcon?.uicon?.svg_code}
                color="azure"
                className={s.button}
              >
                {button?.text}
              </ButtonWithIcon>
            )}
          </div>
        </div>
        <div className={s.right}>
          <LineMap cities={cities} className={s.lineMap} />
        </div>
      </Container>
    </section>
  );
};

HowToGetSection.displayName = "HowToGetSection";
